export default __webpack_public_path__ + "static/media/testimonial-2start-banner.a8ec962d.png";